import { Container } from "@mui/material";
import PageTitle from "components/molecules/PageTitle";
import CommandeListe from "components/organisms/CommandeListe";
import type Commande from "models/Commande";
import { dateUtil } from "@sdeapps/react-core";
import { useEffect, useState } from "react";
import type { ReactNode } from "react";
import commandesService from "services/commandesService";
import UserCommandesPageSkeleton from "components/organisms/UserCommandesPageSkeleton";
import { enqueueSnackbar } from "notistack";
import ToastMessages from "constants/ToastMessages";
import { useScrollToTop } from "hooks";

function UserCommandPage(): ReactNode {
  const [userCommandes, setUserCommandes] = useState<Array<Commande>>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useScrollToTop();

  useEffect(() => {
    // TODO utiliser useErrorHandler()
    async function getData(): Promise<void> {
      setIsLoading(true);
      try {
        const commandes = await commandesService.getAllByMe();
        commandes.sort((a, b) => dateUtil.compareDesc(a.dateCommande, b.dateCommande));
        setUserCommandes(commandes);
      } catch (error) {
        enqueueSnackbar(ToastMessages.ERROR_RETRY, { variant: "error" });
      } finally {
        setIsLoading(false);
      }
    }

    void getData();
  }, []);

  return isLoading ? (
    <UserCommandesPageSkeleton />
  ) : (
    <>
      <PageTitle title="Mes commandes" />
      <Container maxWidth="xl">
        <CommandeListe commandes={userCommandes} displayArticleListHeader displayCommentaires />
      </Container>
    </>
  );
}

export default UserCommandPage;
